import { organisationConstants } from '../../../_constants/organisation.constants';
import { organisationService } from '../../../_services/organisation.service';

import {getManageMetricAction} from './getManageMetricList.action';

export const deleteManageMetricAction = {
    deleteManageMetricHandler
};

function deleteManageMetricHandler(orgId, compId) {
    return dispatch => {
        dispatch(request());
        organisationService.deleteManageMetricHandler(orgId, compId)
            .then(
                manageMetricList => {
                    dispatch(success(manageMetricList));
                    dispatch(getManageMetricAction.getManageMetricHandler(orgId, 0))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_DELETE_MANAGE_METRIC } }
    function success(manageMetricList) { return { type: organisationConstants.RECEIVE_DELETE_MANAGE_METRIC, manageMetricList } }
    function failure(error) { return { type: organisationConstants.DELETE_MANAGE_METRIC_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/organisations/ManageMetric/deleteManageMetric.action.js